module.exports = __webpack_public_path__ + "static/media/spanish-adjectives-table-2.e3176ea6.JPG";